import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {IconOk} from '../../../ui/Icons'
import {RetryPayment} from './RetryPayment'

///////////////////////////////////////////////////////////////////////////////

export const MPoSInitialization = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const transactionId =
    api.transactionInfo && api.transactionInfo.epp_transaction_id

  if (!transactionId) {
    return null
  }

  const forwardUrl = 'raisenow://mpos?trx=' + transactionId
  const forward = () => window.open(forwardUrl, '_blank')

  const subtitle = api.trans(
    'blocks.payment_status.mpos_initialization.subtitle',
  )
  const textHTML = api.trans(
    'blocks.payment_status.mpos_initialization.text_html',
  )
  const forwardButton = api.trans(
    'blocks.payment_status.mpos_initialization.forward',
  )

  const showRetryPaymentButton = api.resolveConfigWithSingleResult<boolean>(
    'showRetryPaymentButton',
  )
  const retryPaymentText = api.trans(
    'blocks.payment_status.mpos_initialization.retry_payment',
  )

  return (
    <section className="mpos-initialization">
      <div className="header">
        <div className="title">
          <IconOk />
          <h2 className="text">{subtitle}</h2>
        </div>
      </div>
      <div className="main" dangerouslySetInnerHTML={{__html: textHTML}} />
      <div className="actions">
        <button
          type="button"
          className="btn btn-block btn-primary"
          onClick={forward}
        >
          <span className="btn-text">{forwardButton}</span>
        </button>
      </div>
      {showRetryPaymentButton && (
        <RetryPayment text={retryPaymentText} className="retry-payment-line" />
      )}
    </section>
  )
})
